var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDankort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_36",
    "data-name": "Group 36",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.168,
    height: 29.859,
    viewBox: "0 0 45.168 29.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 45.168,
    height: 29.859,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 38.993,
    height: 25.776,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(3.247 2.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M789.391,15.841a11.511,11.511,0,1,0,0,23.022h15.5a11.511,11.511,0,0,0,0-23.022Z",
    transform: "translate(-777.643 -14.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M804.5,38.707H789a11.745,11.745,0,1,1,0-23.489h15.5a11.745,11.745,0,0,1,0,23.489M789,15.452a11.511,11.511,0,1,0,0,23.022h15.5a11.511,11.511,0,0,0,0-23.022Z",
    transform: "translate(-777.254 -14.074)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M857.116,36.357l5.155,6.131a9.538,9.538,0,0,0-.183-11.11Z",
    transform: "translate(-827.155 -24.172)",
    fill: "#d9001c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M800.058,24.4c3.85,0,6.751.979,7.049,4.223l4.051-4.224h8.068a9.544,9.544,0,0,0-7.271-3.359h-15.5a9.544,9.544,0,0,0-7.272,3.36Z",
    transform: "translate(-784.705 -17.713)",
    fill: "#d9001c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M798.976,40.9l-1.375,3.78h5.547c1.64,0,2.136-.679,2.5-1.986s-.549-1.794-1.67-1.794Z",
    transform: "translate(-789.967 -30.12)",
    fill: "#d9001c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M810.839,53.349l-4.285-5.415c-.793,3.692-3.386,5.415-8.248,5.415h-9.69a9.547,9.547,0,0,0,7.484,3.617h15.5a9.547,9.547,0,0,0,7.482-3.617Z",
    transform: "translate(-784.352 -34.517)",
    fill: "#d9001c"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDankort);
export default __webpack_public_path__ + "static/media/dankort.faabecb7.svg";
export { ForwardRef as ReactComponent };